// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"4a87880e","129":"5f196000","253":"ede179be","520":"4ff48a6d","789":"46710f17","833":"240ae7ce","851":"06d8f327","856":"27e9d06e","928":"f9eeaee0"}[chunkId] + ".chunk.js";
};